/* no-unused-vars */
import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  // TeamButton,
  // HeaderWrapperV2,
  // DividerLine,
  BuddyTabContainer,
  BuddyTab1,
  // BottomCard,
  // BottomCardWrapper
} from "../PeopleHomeV2/styles";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  fetchCompanyTeamUsers,
  fetchCompanyTeamCount,
  fetchUsersToAddToTeam,
  fetchTeamDetailsById,
  fetchDeleteTeam,
  addChallengeTeams,
  addChallengeTeamsV2,
} from "../../redux/actions";
import {
  // AddMemberButton,
  CardWrapper,
  // CustomDropdownMenue,
  // CustomDropdownMenuItem,
  // MemberData,
  // TeamCard,
  // AddNewTeam,
  // TeamImage,
  Layout,
  Main,
  SeeAllStyledModal,
  TeamCardNew,
  // MemberDataV2,
  CustomTitle,
  CaptainLogo,
  MemberDataV3,
  TeamCreationNotification,
  // ToolTip,
  // BottomStroke,
} from "./styles";
import { UserButton } from "../EngagementSection/styles";
import { PaginationCircleNew } from "../Journeys/styles";
import { PaginationCard } from "../DailyTipAdmin/styles";
import isNull from "lodash/isUndefined";
import Waiting from "../Waiting";
import AddUsersToTeamPopup from "./addEmployeeToTeamPopup";
import TeamDetailsPopup from "./teamInfoPopup";
import { ImageUrl } from "../../utils/constants";
import { Modal } from "react-bootstrap";
import { /*OverlayTrigger,Popover */} from "react-bootstrap";
// import LazyImage from "../common/LazyImage/LazyImage";
// import DeletePopup from '../common/deletePopup'
import HoverButton from "../common/HoverButton";
import {  AddEmployeeIcon, /*MenuDotsIcon,EmployeeCountIcon, AddTeamIcon, ViewProfileIcon,wellnessChampionIcon, menuDotsIcon, PaginationIcon, PrintNewIcon, DownloadIcon,*/ PaginationArrowIcon } from "../../utils/icons";
import { toast } from "react-toastify";
import { BASE_URL } from "../../utils/config";
import { GetTeamUsers } from "../../redux/constants/apiConstants";
import CSVList from "../AttendeesModal/CSVList";
// import { t } from "i18next";
import {NoTeam, VerticalDotsIcon, Captain, CloseIconBranding} from '../../utils/icons'
import {CommonButton, CommonButtonBorder} from '../common/commonStyles'
import {NoData, WrapCard, ManagerCard, Card} from './styles'
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import {DownAngleV2} from '../SocialFeedsV2/styles'
import DeletePopup from '../DeletePostPopup/deletePopupBranding'
import {HeaderPopup, StyledModal, StyledModalBody, ScrollWrapper} from '../HealthDataManagement/styles'
import {Theme} from '../EngagementSectionV2/styles'
import { NameInitials } from "../Manager/styles";
import { getInitials } from "../../utils/methods";

class AdminTeamMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTeams: true,
      onHover: -1,
      companyId: props.companyInfo["id"],
      pageNo: 1,
      limit: 15,
      paginationCount: "",
      minLimit: 1,
      maxLimit: "",
      countingValues: "",
      showModal: false,
      teamDetailsModal: false,
      teamId: null,
      SeeAll: false,
      SeeAllMembersData: [],
      teamIndex: null,
      teamName: null,
      maxTeamMemeberCount: null,
      teamMembersCount: null,
      timeout: false,
      teamButtonActive: false,
      showDeleteTeamPopup: false,
      deleteTeamID:null,
      teamUsers:[],
      csvHeaders:[ { label: "Team Name", key: "team_name" }, { label: "First Name", key: "first_name" },
        { label: "Last Name", key: "last_name" },
        { label: "Email", key: "email" },
        { label: "Department", key: "department" },
        { label: "Location", key: "city" },],
      isPrint:false
    };
  }
  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    this.fetchCompanyTeamUsersAPI();
    const { fetchCompanyTeamCount, teamsCount } = this.props;
    const { companyId } = this.state;
    if (isNull(teamsCount) || !teamsCount) {
      fetchCompanyTeamCount(companyId);
    }
    if (teamsCount && !isNull(teamsCount)) {
      this.setState({
        paginationCount: teamsCount["team_count"],
      });
    }

    this.fetchTeamUsers(companyId)
  }

  componentDidUpdate() {
    this.state.timeout &&
      window.setTimeout(() => {
        this.setState({ timeout: false });
      }, 5000);
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener("mousedown", this.handleClick)  }

  fetchTeamUsers = async (companyId) => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    await fetch(BASE_URL + GetTeamUsers  + '/' + companyId, {
      method: "GET",
      headers: { AUTHTOKEN: AuthToken },
      credentials:'include',
      withCredentials: true
    })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if (this._isMounted) {
              this.setState({teamUsers:data.data})
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  progress = () => {
    this.setState({ timeout: false });
  };

  UNSAFE_componentWillReceiveProps() {
    const { paginationCount } = this.state;
    if (
      !paginationCount &&
      paginationCount.length === 0 &&
      this.props.teamsCount &&
      !isNull(this.props.teamsCount)
    ) {
      this.setState({
        paginationCount: this.props.teamsCount["team_count"],
      });
    }
    if (paginationCount && this.state.countingValues !== paginationCount) {
      this.setState(
        {
          total: Math.ceil(paginationCount / 15),
          countingValues: paginationCount,
        },
        () => {
          if (this.state.total < 6) {
            this.setState({
              maxLimit: this.state.total,
            });
          } else {
            this.setState({
              maxLimit: 6,
            });
          }
        }
      );
    }
  }


  onHoverMouse = (id) => {
    this.setState({
      onHover: id
    })
  };

  onLeaveHoverMouse = () => {
    this.setState({
      onHover: -1
    })
  };

  showDeletePopup = (id) => {
    this.setState({ showDeleteTeamPopup: true, deleteTeamID:id });
  };

  hideDeletePopup = () => {
    this.setState({ showDeleteTeamPopup: false });
  };

  fallBack = (e) => {
    e.target.src = "/images/default.png";
  };

  fetchCompanyTeamUsersAPI = () => {
    const { fetchCompanyTeamUsers } = this.props;
    const { companyId, pageNo, limit } = this.state;
    fetchCompanyTeamUsers(companyId, pageNo, limit);
  };

  teamRedirect = () => {
    const { history } = this.props;
    history.push("/company/people/team-creation");
  };

  hideShowTeam = (status) => {
    const { history } = this.props;
    this.setState({ showTeams: status });
    if (!status) {
      history.push("/company/people");
    }
  };
  
  hideShowInactiveUsers = (status) => {
    const { history } = this.props;
    this.setState({ showTeams: status })
    if(status){
      history.push('/company/people/inactive-users')
    }
  }

  goToRoles = () => {
    const { history } = this.props;
    // Redirect to main people page with Roles tab active
    history.push("/company/people?tab=roles");
  };

  hideAddEmployeePopUp = () => {
    this.setState({
      showModal: false,
    });
  };
  hideTeamDetailsPopUp = () => {
    this.setState({
      teamDetailsModal: false,
    });
  };

  getPaginationCircle = () => {
    let circleButton = [];
    for (let i = this.state.minLimit; i <= this.state.maxLimit; i++) {
      circleButton.push(
        <PaginationCircleNew
          key={i}
          active={i == this.state.pageNo}
          onClick={() => this.setPagination(i)}
        >
          <div>{i}</div>
        </PaginationCircleNew>
      );
    }
    return circleButton;
  };

  handleSeeAll = (data) => {
    this.setState({ SeeAll: true, SeeAllMembersData: data });
  };

  hideSeeAllModal = () => {
    this.setState({ SeeAll: false });
  };

  showAllMembers = () => {
    const { SeeAllMembersData, SeeAll } = this.state;
    return(
      <StyledModal
        transform={1}
        show={SeeAll}
        newWidth={"432px"}
        newBg={"newBg"}
        height="50px"
        display="none"
        onHide={() => this.hideSeeAllModal()}
      >
        <HeaderPopup>
          <div className="title">Team Details</div>
          <div className="closeIcon" onClick={() => this.hideSeeAllModal()}>
            {CloseIconBranding()}
          </div>
        </HeaderPopup>
        <div className="border-top"/>
        <StyledModalBody padding="16px 4px 16px 24px !important">
          <ScrollWrapper height={"380px"} scroll margin="0">
            {SeeAllMembersData?.map((item, index)=>
              (<Theme radius width="48px" key={index} background="transparent" backgroundM="transparent" margin="0 24px 0 0">
                {item?.profile_image !== "profile-Image/default.png"? <div className='image'>
                  <img src={`${ImageUrl}/${item?.profile_image}`} />
                </div>:<NameInitials margin="0 12px 0 0px">{getInitials(item?.fullname)}</NameInitials>}
                <div className='wrap-theme'>
                  <div className='fullname' style={{alignItems:"center", display:"flex"}}>{`${item.fullname}`}
                    <span className="captain">{item?.is_captain?"(Captain)":""}</span>
                    {item?.is_champion?Captain():null}
                  </div>
                </div>
              </Theme>)
            )}
          </ScrollWrapper>
        </StyledModalBody>
      </StyledModal>
    )
  }

  SeeAllModal = () => {
    const { SeeAllMembersData, SeeAll } = this.state;
    return (
      <SeeAllStyledModal
        show={SeeAll}
        onHide={this.hideSeeAllModal}
        dialogClassName="modal-90w"
      >
        <Modal.Header>
          <CustomTitle>
            <div>
              <span>Team Details</span>
              <span className="closeImage" onClick={this.hideSeeAllModal}>
                <img src="/public/images/new_close_icon.png" />
              </span>
            </div>
          </CustomTitle>
        </Modal.Header>
        <Modal.Body>
          <TeamCardNew>
            <div className="teamDetails">
              {SeeAllMembersData.length > 0
                ? SeeAllMembersData.map((member, index) => (
                  <MemberDataV3
                    key={index}
                    captain={member.is_captain === 1}
                    border={index === 0}
                  >
                    <div className="imageDiv">
                      {" "}
                      {member.is_captain === 1 && (
                        <CaptainLogo src="/public/images/captain-band.png" />
                      )}
                      <img
                        src={`${ImageUrl}/${member.profile_image}`}
                        alt="people_icon"
                      />{" "}
                    </div>
                    <div className="textBox">
                      <h1>
                        {member.fullname}{" "}
                        {member.is_captain === 1 && (
                          <span className="max"> &nbsp;(Captain)</span>
                        )}{" "}
                      </h1>
                      {member.is_champion && (
                        <div className="wellnessChampion">
                          <img src={ "/public/images/AdminChallenges/Subtract.png"}/>
                          <span>Wellness Champion</span>
                        </div>
                      )}
                    </div>
                  </MemberDataV3>
                ))
                : null}
            </div>
          </TeamCardNew>
        </Modal.Body>
      </SeeAllStyledModal>
    );
  };

  setPagination = (activeIndex) => {
    if (activeIndex !== this.state.pageNo) {
      if (this.state.total <= 6) {
        this.setState(
          {
            minLimit: 1,
            maxLimit: this.state.total,
            pageNo: activeIndex,
          },
          () => {
            this.fetchCompanyTeamUsersAPI();
          }
        );
      } else {
        if (activeIndex === 1) {
          this.setState(
            {
              pageNo: activeIndex,
              maxLimit: 6,
              minLimit: 1,
            },
            () => {
              this.fetchCompanyTeamUsersAPI();
            }
          );
        } else {
          if (activeIndex + 3 > this.state.total) {
            this.setState(
              {
                pageNo: activeIndex,
                maxLimit: this.state.total,
                minLimit: this.state.total - 4,
              },
              () => {
                this.fetchCompanyTeamUsersAPI();
              }
            );
          } else {
            this.setState(
              {
                pageNo: activeIndex,
                maxLimit: activeIndex + 3,
                minLimit: activeIndex - 1,
              },
              () => {
                this.fetchCompanyTeamUsersAPI();
              }
            );
          }
        }
      }
    }
  };

  viewTeamDetails = (teamId, tName, index, count) => {
    this.setState({
      teamDetailsModal: true,
      teamName: tName ? tName : `Team ${index + 1}`,
      maxTeamMemeberCount: count,
    });
    this.props.fetchTeamDetailsById(teamId);
  };

  viewUsersToAdd = (id, count, teamMemberCount) => {
    const { fetchUsersToAddToTeam } = this.props;
    const { companyId } = this.state;
    this.setState({
      showModal: true,
      teamId: id,
      maxTeamMemeberCount: count,
      teamMembersCount: teamMemberCount,
    });
    let obj = {};
    obj["company_id"] = companyId;
    this.props.fetchTeamDetailsById(id);
    fetchUsersToAddToTeam(obj);
  };

  deleteTeam = () => {
    const { fetchDeleteTeam } = this.props;
    const { pageNo, companyId, limit, deleteTeamID } = this.state;
    this.setState(
      {
        deleteTeamID:null, showDeleteTeamPopup: false
      },
      () => {
        fetchDeleteTeam(deleteTeamID, companyId, pageNo, limit);
      }
    );
  };

  addNewTeam = () => {
    this.setState(
      {
        timeout: true,
      },
      () => {
        this.addNewTeamAPI();
      }
    );
  };

  addNewTeamAPI = () => {
    const { addChallengeTeamsV2 } = this.props;
    const { companyId, pageNo, limit } = this.state;
    const TeamDetails = {
      user_count: 25,
      team_count: 1,
      team_creation_type: "manual",
      company_id: companyId,
    };
    addChallengeTeamsV2(TeamDetails, companyId, pageNo, limit);
  };

  teamButtonStatusHover = () => {
    this.setState({
      teamButtonActive: true,
    });
  };

  teamButtonStatus = () => {
    this.setState({
      teamButtonActive: false,
    });
  };

  showTeamButton = () => {
    const { teamButtonActive, showTeams } = this.state;
    const{/*companyInfo,*/ userCompany, searchAmigo, role, allRoles}=this.props;
    const hasAnyRole = allRoles?.some(
      (data) => [3, 11, 12].includes(data?.rid)
    );
    
    return (
      <BuddyTabContainer>
        <div style={{width: 'auto', display: 'flex', justifyContent: 'flex-start'}}>
          <BuddyTab1
            active={showTeams ? false : true}
            onClick={() => this.hideShowTeam(false)}
            style={{width:"auto",padding:"0 15px"}}
          >
            {"Active"}
          </BuddyTab1>
          {(hasAnyRole) && <BuddyTab1 active={showTeams ? false : true} onClick={() => this.hideShowInactiveUsers(true)} style={{width:"auto",padding:"0 15px"}}> {"Inactive"}</BuddyTab1>}
          {!searchAmigo && ((role==="ADMIN"|| role === "WELLNESS_ADMIN" || role === "WELLNESS_CHAMPION") || userCompany && userCompany.showTeam) && <BuddyTab1 active={showTeams ? true : false} style={{width:"auto",padding:"0 15px"}}> {"Teams"}</BuddyTab1>}
          
          {/* Roles Tab Added Here */}
          {!searchAmigo && (
            <BuddyTab1 
              onClick={this.goToRoles} 
              active={false} 
              style={{ width: "auto", padding: "0 15px" }}
            >
              {"Roles"}
            </BuddyTab1>
          )}

        </div>
      
        <div style={{display:"flex",flexDirection:"row", justifyContent:"end", width:"100%"}}>
          <div style={{marginRight: "8px"}}>
            <HoverButton title={"Add a Team"} svgPath={AddEmployeeIcon()} onClick={() => this.addNewTeam()} disabled={teamButtonActive} activeColor={"#F37A65"}
              inActiveColor={"#F37A65"}
              backgroundColor={"white"}
              backgroundColorActive={"#F37A65"}
              width={"24px"}
              height={"24px"} fillOpacity={"1"}/>
          </div>
        </div>
      </BuddyTabContainer>
    );
  };

  render() {
    const {
      paginationCount,
      pageNo,
      companyId,
      teamId,
      teamName,
      limit,
      teamDetailsModal,
      maxTeamMemeberCount,
      teamMembersCount,
      timeout,
      showDeleteTeamPopup,
    } = this.state;
    const {
      teamsUsersData,
      teamsCount,
      teamUsers,
      teamDetailsData,
      teamIcons
    } = this.props;
    if (!teamsCount || isNull(teamsCount)) {
      return <Waiting />;
    }
    return (
      <Layout>
        <Main>
         
          {timeout && (
            <TeamCreationNotification>
              <div className="card-style">
                <div className="icon">
                  <img src="/public/images/whitetick.svg" alt="arrow" />
                </div>
                <div className="buttonName">
                  New Team card Added at last position of the queue
                </div>
              </div>
            </TeamCreationNotification>
          )}
          {this.showTeamButton()}
          {teamsUsersData && teamsUsersData.length ? (
            <CardWrapper margin="1">
              <div className="teamWrapper">
                <WrapCard>
                  {teamsUsersData && teamsUsersData?.length ? 
                    teamsUsersData.map((team, index)=>(
                      <div className='user-card' key={index}>
                        <ManagerCard>
                          <div className='heading'>
                            {team.logo?<div className='image'>
                              <img src={team.logo? `${ImageUrl}/${team?.logo}`:`${ImageUrl}/images/PeoplePage/teams-logo.svg`}/>
                            </div>:<NameInitials>{getInitials(team?.name)}</NameInitials>}
                            <div className='title'>{team?.name}</div>
                            <div className='menu'>
                              <DownAngleV2  feed>
                                <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>}>
                                  <Dropdown.Item onClick={() =>this.viewTeamDetails(team.id,team.name,index,team.count)}>
                                    {("Edit Details")}
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => this.viewUsersToAdd( team.id,team.count,team.team_users ? team.team_users.length : 0) }>
                                    {("Add Member")}
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => this.showDeletePopup(team.id)}>
                                    {("Delete Team")}
                                  </Dropdown.Item>
                                </DropdownButton>
                              </DownAngleV2>
                            </div>
                          </div>
                          <div className='wrap-user'>
                            {team?.team_users?.length > 0?
                              team?.team_users.slice(0,5)?.map((user,index)=>
                                <Card key={index}>
                                  {user?.profile_image !== "profile-Image/default.png"? <div className='image'>
                                    <img src={`${ImageUrl}/${user?.profile_image}`} />
                                  </div>:<NameInitials>{getInitials(user?.fullname)}</NameInitials>}
                                  <div className='wrap'>
                                    <div className='name'>{user?.fullname}</div>
                                  </div>
                                  <span className="caption-text">{user.is_captain?"Captain":""}</span>
                                  {user.is_champion?<div className="captain">{Captain()}</div>:null}
                                </Card>):
                              <div className='button-wrap'>
                                <CommonButtonBorder onClick={() => this.viewUsersToAdd( team.id,team.count,team.team_users ? team.team_users.length : 0) }>Add Members</CommonButtonBorder>
                              </div> 
                            }
                          </div>
                          {team?.team_users?.length>5?<div className="more" onClick={() => this.handleSeeAll(team.team_users)}>See more</div>:null}
                        </ManagerCard>
                      </div>)):null}
                  <div className='user-card'>
                    <ManagerCard>
                      <div className='wrap-user'>
                        <div className='button-wrap'>
                          <CommonButtonBorder onClick={() => this.addNewTeam()}>Add Team</CommonButtonBorder>
                        </div> 
                      </div>
                    </ManagerCard>
                  </div>
                </WrapCard>
              </div>
              {paginationCount > 15 && (
                <PaginationCard>
                  {pageNo > 1 && (
                    <UserButton
                      width="32px"
                      height="32px"
                      Align={1}
                      float={1}
                      padding="4px"
                      fontSize="8px"
                      bgColor="transparent"
                      capitalize={1}
                      isDisplay="flex"
                      isJustify="center"
                      isAlign="center"
                      onClick={() => this.setPagination(pageNo - 1)}
                    >
                      <div style={{transform:"rotate(180deg)",marginLeft:"20px"}}> {PaginationArrowIcon()}</div>
                    </UserButton>
                  )}
                  {this.getPaginationCircle()}
                  {pageNo != this.state.total && (
                    <UserButton
                      width="32px"
                      height="32px"
                      Align={1}
                      marginLeft="10px"
                      fontSize="18px"
                      padding="4px"
                      bgColor="transparent"
                      capitalize={1}
                      isDisplay="flex"
                      isJustify="center"
                      isAlign="center"
                      onClick={() => this.setPagination(pageNo + 1)}
                    >
                      <div> {PaginationArrowIcon()} </div>
                    </UserButton>
                  )}
                </PaginationCard>
              )}
            </CardWrapper>
          ) : (
            <NoData>
              <div className='image'>{NoTeam()}</div>
              <div className='no-data'>Create Team</div>
              <div className='subtext'>Foster teamwork by grouping employees into teams and driving collaboration forward!</div>
              <div className='button'>
                <CommonButton onClick={() => this.teamRedirect()}>Create Now</CommonButton>
              </div>
            </NoData>
          )}
        </Main>
        {this.showAllMembers()}
        <AddUsersToTeamPopup
          showModal={this.state.showModal}
          hideModal={this.hideAddEmployeePopUp}
          teamUsers={teamUsers}
          companyId={companyId}
          teamId={teamId}
          teamcount={teamDetailsData}
          pageNo={pageNo}
          limit={limit}
          memberCount={maxTeamMemeberCount}
          teamMembersCount={teamMembersCount}
        />
        {teamDetailsModal && (
          <TeamDetailsPopup
            peopleTeams={true}
            showAddModal={this.viewUsersToAdd}
            showModal={this.state.teamDetailsModal}
            hideModal={this.hideTeamDetailsPopUp}
            teamDetailsData={teamDetailsData}
            teamIcons={teamIcons[0]}
            defaultTeamName={teamName}
            pageNo={pageNo}
            limit={limit}
            companyId={companyId}
            maxTeamMemeberCount={maxTeamMemeberCount}
          />
        )}
        {showDeleteTeamPopup&&<DeletePopup
          showModal={showDeleteTeamPopup}
          onClose={this.hideDeletePopup}
          deleteConsumer={this.deleteTeam}
          type="Team"
        />}  

        {this.state.isPrint && <CSVList Title={"Team Users"} removeCSVData={()=>this.setState({isPrint:false})} headers={this.state.csvHeaders} data={this.state.teamUsers || []} />}
      </Layout>
    );
  }
}

AdminTeamMain.defaultProps = {
  companyInfo: { id: 1, name: "" },
};

AdminTeamMain.propTypes = {
  history: PropTypes.object.isRequired,
  teamsUsersData: PropTypes.array,
  fetchCompanyTeamUsers: PropTypes.func,
  companyInfo: PropTypes.object,
  teamsCount: PropTypes.array,
  fetchCompanyTeamCount: PropTypes.func,
  fetchUsersToAddToTeam: PropTypes.func,
  teamUsers: PropTypes.array,
  fetchTeamDetailsById: PropTypes.func,
  teamDetailsData: PropTypes.array,
  fetchDeleteTeam: PropTypes.func,
  teamIcons: PropTypes.array,
  addChallengeTeams: PropTypes.func,
  addChallengeTeamsV2: PropTypes.func,
  role:PropTypes.string,
  userCompany: PropTypes.object,
  searchAmigo: PropTypes.bool,
  allRoles:PropTypes.array
};

const mapStateToProps = (state) => ({
  teamsUsersData: state.adminTeamCreation.teamsUsersData,
  teamsCount: state.adminTeamCreation.teamsCount,
  teamUsers: state.adminTeamCreation.teamUsers,
  teamDetailsData: state.adminTeamCreation.teamDetailsData,
  teamIcons: state.adminTeamCreation.teamIconsData,
  userCompany: state.profileData.userCompany,
  allRoles: state.profileData.allRoles,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCompanyTeamUsers: (companyId, PageNo, limit) => dispatch(fetchCompanyTeamUsers(companyId, PageNo, limit)),
  fetchCompanyTeamCount: (companyId) => dispatch(fetchCompanyTeamCount(companyId)),
  fetchUsersToAddToTeam: (object) => dispatch(fetchUsersToAddToTeam(object)),
  fetchTeamDetailsById: (teamId) => dispatch(fetchTeamDetailsById(teamId)),
  fetchDeleteTeam: (teamId, companyId, pageNo, limit) => dispatch(fetchDeleteTeam(teamId, companyId, pageNo, limit)),
  addChallengeTeams: (obj, companyId) => dispatch(addChallengeTeams(obj, companyId)),
  addChallengeTeamsV2: (obj, companyId, pageNo, limit) => dispatch(addChallengeTeamsV2(obj, companyId, pageNo, limit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AdminTeamMain));